var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"m-inactiveJobCupcake\">\n    <div class=\"m-inactiveJobCupcake__spot\">\n"
    + ((stack1 = container.invokePartial(require("../spot/template.hbs"),depth0,{"name":"module/spot/template","hash":{"class":"m-jobsInfoBox__spot","size":"m","pageEmpty":true},"data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n    <p class=\"m-inactiveJobCupcake__text\">\n        "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"cupcakeText") : depth0), depth0)) != null ? stack1 : "")
    + "\n    </p>\n</div>\n";
},"usePartial":true,"useData":true});